import axios from "axios";

/**
 * Fetch product suggestions from API
 * @param {string} searchText - The search query (must be at least 3 characters)
 * @returns {Promise<Array>} - List of product suggestions
 */
export const fetchSuggestions = async (searchText, page = 1, sortBy = 'id', order = 'desc', signal) => {
  if (searchText.length < 3) return [];

  try {
    const response = await axios.post(
      "https://spot.ul-dev.com/data/spot/api/v1/en/Products/Search",
      {
        keywords: searchText,
        filters: [],
        page: page
      },
      {
        headers: {
          "Content-Type": "application/json",
          Aid: "5a5856538404691cc28fee28",
          Authorization: "Basic MjIzNDU2Nzg5MDp5d2VydHlIaW9wMDk4NzY1NDMyMQ==",
          Referer: "https://spot.ul.com",
        },
      }
    );

    return response.data.items || []; // ✅ Fix: Correcting the API response structure
  } catch (error) {
    console.error("Error fetching suggestions", error);
    return [];
  }
};
